import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Sidebar from "../components/Sidebar";

export default function ITaxQuest() {
  const navigate = useNavigate();

  // Removed manual sidebar state




  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#0b0b0d",
        color: "#e5e7eb",
        padding: 24,
        boxSizing: "border-box",
      }}
    >
      {/* local CSS helpers */}
      <style>{`
        .no-scrollbar {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .two-line {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>

      <div
        style={{
          maxWidth: "100%",
          margin: "0 auto",
          minHeight: 720,
          display: "flex",
          gap: 24,
        }}
      >
        {/* ---------------- Sidebar ---------------- */}
        {/* ---------------- Sidebar ---------------- */}
        <Sidebar activeKey="itaxquest" />

        {/* ---------------- Main Content ---------------- */}
        {/* ---------------- Main Content ---------------- */}
        <main
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: 260, // Account for fixed sidebar
            width: "calc(100% - 260px)"
          }}
        >
          <div style={mainCard}>
            <div style={{ display: "flex", gap: 10 }}>
              <img
                src="/star.png"
                alt="star"
                style={{
                  width: 40,          // smaller, subtle
                  height: 40,
                  marginTop: 6,       // aligns with text baseline
                  opacity: 0.9,       // softer look like screenshot
                  flexShrink: 0,
                }}
              />

              <div>
                <h1 style={title}>Hi Admin!</h1>
                <p style={subtitle}>
                  What information about tax filing & compliance do you need
                  today?
                </p>
              </div>
            </div>

            <div
              style={{
                width: "100%",
                height: 59,
                borderRadius: 10,
                padding: "12px 18px",
                background: "#242424",
                border: "1px solid #606060",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxSizing: "border-box",
              }}
            >
              <input
                placeholder="Start typing here..."
                style={{
                  width: "100%",
                  border: "none",
                  background: "transparent",
                  color: "#606060",
                  fontSize: 16,
                  fontStyle: "italic",
                  outline: "none",
                }}
              />
              <button style={sendBtn}>
                <img src="/send.png" alt="send" width={30} />
              </button>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

/* ---------------- Styles ---------------- */

const navItem: React.CSSProperties = {
  padding: "12px 16px",
  borderRadius: 8,
  color: "#9ca3af",
  display: "flex",
  alignItems: "center",
  gap: 12,
  textDecoration: "none",
  fontWeight: 500,
};

const activeItem = {
  backgroundColor: "#1d2236",
  color: "#60a5fa",
};

const navButton = (open: boolean): React.CSSProperties => ({
  ...navItem,
  background: open ? "#111317" : "transparent",
  border: "none",
  width: "100%",
  cursor: "pointer",
});

const submenuBox: React.CSSProperties = {
  marginTop: 8,
  marginLeft: 6,
  padding: 8,
  borderRadius: 8,
  background: "#0f1113",
  border: "1px solid #1b1b1d",
};

const submenuActive: React.CSSProperties = {
  padding: "8px 12px",
  borderRadius: 12,
  background: "linear-gradient(90deg,#1f2937,#111827)",
  color: "#fff",
  textAlign: "center",
  display: "block",
};

const submenuInactive: React.CSSProperties = {
  padding: "8px 12px",
  borderRadius: 12,
  border: "1px solid rgba(255,255,255,0.03)",
  color: "#cbd5e1",
  textAlign: "center",
  display: "block",
};

const profileCard: React.CSSProperties = {
  position: "absolute",
  bottom: 60,
  left: "50%",
  transform: "translateX(-50%)",
  width: 150,
  height: 234,
  background: "#16161a",
  borderRadius: 20,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 10,
  paddingTop: 12,
};

const avatar: React.CSSProperties = {
  width: 60,
  height: 60,
  borderRadius: "50%",
};

const logoutBtn: React.CSSProperties = {
  width: 40,
  height: 40,
  borderRadius: "50%",
  background: "#0b0b0d",
  border: "1px solid rgba(255,255,255,0.14)",
};

const mainCard: React.CSSProperties = {
  width: 930,
  height: 265,
  padding: 20,
  borderRadius: 6,
};

const title = {
  fontSize: 20,
  fontWeight: 700,
};

const subtitle = {
  fontSize: 20,
};

const inputWrapper: React.CSSProperties = {
  marginTop: 24,
  height: 59,
  borderRadius: 10,
  background: "#242424",
  border: "1px solid #606060",
  display: "flex",
  alignItems: "center",
  padding: "12px 18px",
};

const inputStyle: React.CSSProperties = {
  flex: 1,
  background: "transparent",
  border: "none",
  color: "#606060",
  fontSize: 16,
};

const sendBtn: React.CSSProperties = {
  background: "transparent",
  border: "none",
  cursor: "pointer",
};

